const s = {
  name: "Support",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,14C8,7.4,13.4,2,20,2s12,5.4,12,12v18c0,1.7-1.3,3-3,3h-5.1c-0.4-1.7-2-3-3.9-3c-2.2,0-4,1.8-4,4
			c0,2.2,1.8,4,4,4c1.9,0,3.4-1.3,3.9-3H29c2.8,0,5-2.2,5-5v-3h6V15h-6v-1c0-7.7-6.3-14-14-14S6,6.3,6,14v1H0v14h8V14z M34,27V17h4
			v10H34z M2,17h4v10H2V17z M18,36c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C18.9,38,18,37.1,18,36z"/>
		<path class="st0" d="M16,18v4h-2v-4H16z"/>
		<path class="st0" d="M26,22v-4h-2v4H26z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Support
};
